import { withSvgIcon } from './withSvgIcon';

export const HuobiWallet = withSvgIcon(
  <>
    <path
      d="M29.1996 15.9287C29.1996 9.89337 26.2262 4.70856 23.9664 3.01869C23.9664 3.01869 23.7942 2.92392 23.806 3.16117C23.6202 14.8069 17.5997 17.9661 14.2881 22.2174C6.65214 32.0326 13.7554 42.7974 20.9869 44.7766C25.035 45.8916 20.054 42.7974 19.4135 36.2988C18.6323 28.4429 29.1996 22.4391 29.1996 15.9287Z"
      fill="#1F2226"
    />
    <path
      d="M32.4107 19.8299C32.3624 19.7983 32.2986 19.7741 32.254 19.8497C32.1258 21.3203 30.6088 24.4596 28.6816 27.345C22.1545 37.1318 25.8718 41.8458 27.9674 44.3905C29.1716 45.8611 27.9674 44.3905 31.0027 42.8883C34.7517 40.6422 37.1849 36.7589 37.5454 32.4431C37.7436 30.0849 37.3818 27.7131 36.4895 25.5212C35.5972 23.3293 34.1997 21.3792 32.4107 19.8299Z"
      fill="#2D65F8"
    />
  </>,
  { viewBox: '0 0 48 48' },
);
